
import Vue from "vue";
import { deliveryNetworks, siteTypes } from "@/constants/offers";

export default Vue.extend({
  props: {
    deliveryNetworks: {
      type: Array,
      default: () => deliveryNetworks,
      validator(value: string[]) {
        if (!value || value.length === 0) {
          return true;
        }
        return value.every(val => deliveryNetworks.includes(val));
      }
    },
    siteTypes: {
      type: Array,
      default: () => siteTypes,
      validator(value: string[]) {
        if (!value || value.length === 0) {
          return true;
        }
        return value.every(val => siteTypes.includes(val));
      }
    },
    value: {
      type: Array
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasValue(): boolean {
      return this.value && this.value.length > 0;
    },
    hasNetworks(): any {
      return this.deliveryNetworks && this.deliveryNetworks.length > 0;
    },
    networks(): any {
      return this.hasNetworks ? this.deliveryNetworks : [null];
    }
  },
  // TODO - flatten out the object in a computed property for easier consumption
  methods: {
    getIsActive(network: string): boolean {
      if (this.hasValue) {
        return this.value.some(
          (item: any) =>
            item.amountCpl > 0 &&
            (!this.hasNetworks || item.deliveryNetwork === network)
        );
      }

      return false;
    },
    getDiscount(network: string, siteType: string): any {
      if (this.hasValue) {
        return this.value.find(
          (item: any) =>
            item.siteType === siteType &&
            (!this.hasNetworks || item.deliveryNetwork === network)
        );
      }
      return null;
    },
    onIsActiveChange(value: boolean, network: string): void {
      // if the delivery network toggle is switched off
      if (this.hasValue && !value) {
        // clear out all values for that network
        this.$emit(
          "input",
          [...this.value].filter(
            (item: any) => item.deliveryNetwork !== network
          )
        );
      }
    },
    onDiscountChange(value: {
      deliveryNetwork: string;
      siteType: string;
      amountCpl: number;
    }): void {
      // get all values from
      if (!this.hasValue) {
        // no value, create a new array from the value if it has an amount
        if (value.amountCpl > 0) {
          this.$emit("input", [value]);
        }
        return;
      }

      // copy the value for mutating
      const newValue = [...this.value];

      // try find the existing discount value
      const existingIndex = this.value.findIndex(
        (x: any) =>
          x.siteType === value.siteType &&
          (!this.hasNetworks || x.deliveryNetwork === value.deliveryNetwork)
      );

      if (existingIndex < 0) {
        // doesn't exist, add it if it has an amount
        if (value.amountCpl > 0) {
          newValue.push(value);
        } else {
          return;
        }
      } else if (value.amountCpl > 0) {
        // replace the existing discount
        newValue.splice(existingIndex, 1, value);
      } else {
        // remove the existing discount
        newValue.splice(existingIndex, 1);
      }

      this.$emit("input", newValue);
    }
  }
});
